﻿import {hasFlag, translation} from "@2d-front-monorepo/core";
import {
	AttachmentsComponent,
	EntityHistoryStatusComponent,
	PermitFullEntityResult, VehiclePropertyFlags, VehicleId,
	VehicleResult
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {API_ENDPOINT} from "../../../api-endpoint";
import {JSX} from "react";

const filesPrefix = API_ENDPOINT.fileDownload;

export function VehicleComponent({vehicle, hiddenEntityProperties, showStatus}: {
	vehicle: PermitFullEntityResult<VehicleId, VehicleResult>,
	hiddenEntityProperties: VehiclePropertyFlags,
	showStatus: boolean
}): JSX.Element {
	const data = vehicle.entity.data;
	const hideHr = hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Nickname)
		&& hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Model)
		&& hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Color)
		&& hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Type)
		&& hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Province)
		&& vehicle.entity.attachments.length === 0;

	return <>
		<div className="layout horizontal aligned middle card--vehicle__header">
			<h6 className="flex">{translation(PermitTranslations.vehicle__plate)} [<span className="tabular-nums">{vehicle.entity.plate}</span>]</h6>
			{showStatus && <EntityHistoryStatusComponent status={vehicle}/>}
		</div>
		{!hideHr &&
            <>
                <hr/>
                <div className="grid padded">
                    <div className="col-3of4 grid">
						{!hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Nickname) &&
                            <dl className="title-desc col-1of3">
                                <dt>{translation(PermitTranslations.vehicle__nickname)}</dt>
                                <dd>{data?.nickname}</dd>
                            </dl>}
						{!hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Model) &&
                            <dl className="title-desc col-1of3">
                                <dt>{translation(PermitTranslations.vehicle__model)}</dt>
                                <dd>{data?.model}</dd>
                            </dl>}
						{!hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Color) &&
                            <dl className="title-desc col-1of3">
                                <dt>{translation(PermitTranslations.vehicle__color)}</dt>
                                <dd>{data?.color}</dd>
                            </dl>}
						{!hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Type) &&
                            <dl className="title-desc col-1of3">
                                <dt>{translation(PermitTranslations.vehicle__type)}</dt>
                                <dd>{data?.type}</dd>
                            </dl>}
						{!hasFlag(hiddenEntityProperties, VehiclePropertyFlags.Province) &&
                            <dl className="title-desc col-1of3">
                                <dt>{translation(PermitTranslations.vehicle__province)}</dt>
                                <dd>{data?.province}</dd>
                            </dl>}
                    </div>
                    <AttachmentsComponent entity={vehicle.entity} linkPrefix={filesPrefix} className="col-1of4"/>
                </div>
            </>
		}
	</>;
}
